import { Styled } from "./styles";
import Address from "./address";
import Base from "./base";
import Contact from "./contact";
import SubscriptionComponent from "./subscription";
import { Organization, Subscription } from "@/types/entities";
import { useForm } from "react-hook-form";
import { Forms } from "@/types/form";
import { yupResolver } from "@hookform/resolvers/yup";
import schemas from "@/utils/schemas";
import { Backdrop } from "@dippi/ui";
import constant from "@/utils/constant";
import { useSubmit } from "./hooks";
import { useFormListeners } from "@dippi/forms";
import Table from "./members";
import { Grid, Typography } from "@mui/material";

const getDefaultValues = (organization: Organization): Forms["Settings"] => {
    const { title, industry, business, companyId, email, phone, address } = organization;

    return {
        title,
        business,
        companyId,
        email,
        phone,
        industry,
        address: { 
            ...address,
            zipCode: address.zipCode ?? "",
        }
    };
};

interface Props {
    subscription: Subscription;
    organization: Organization;
}

const Form: React.FC<Props> = ({ subscription, organization }) => {
    const { control, handleSubmit, formState } = useForm<Forms["Settings"]>({
        resolver: yupResolver(schemas.settings),
        values: getDefaultValues(organization),
    });
    const { isDirty, isSubmitting } = formState;
    useFormListeners("form-organization-settings", isDirty, isSubmitting);

    const { mutateAsync: onSubmit } = useSubmit();

    return (
        <Styled.Form
            id="form-organization-settings"
            onSubmit={handleSubmit(async data => await onSubmit(data))}
        >
            <Styled.Container container gap={constant.GRID_SPACING}>
                <Base control={control} />
                <Contact control={control} />
                <Address control={control} />
            </Styled.Container>
            <Styled.Container container gap={constant.GRID_SPACING}>
                <SubscriptionComponent subscription={subscription} />
            </Styled.Container>
            <Styled.Container container>
                <Grid item xs={12}>
                    <Typography variant="h3">Organization members</Typography>
                </Grid>
                <Table />
            </Styled.Container>
            <Backdrop loading={isSubmitting} />
        </Styled.Form>
    );
};

export default Form;
